import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Zap } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../../ui/dialog";
import { api } from "../../../lib/api";
import { buyCredits } from "../../../lib/buyCredits";
import { BALANCE_EVENT } from "./RechargeBanner";

const CHIPS = [100, 500, 1000, 5000];
const OPS = { create: api.adminPanelCreateOrder, verify: api.adminPanelVerify };

export const PanelTopupDialog = ({ open, price, onClose, onDone }) => {
  const [credits, setCredits] = useState(500);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setCredits(500); }, [open]);
  const n = Number(credits || 0);
  const ok = Number.isInteger(n) && n >= 1 && n <= 1000000;
  const amount = Math.max(1, Math.ceil(n * price * 100) / 100);

  const pay = () => {
    setBusy(true);
    buyCredits({ credits: n }, {
      onSuccess: (r) => { toast.success(`${r.credits_added || n} credits added to your panel`); setBusy(false); window.dispatchEvent(new Event(BALANCE_EVENT)); onDone(); onClose(); },
      onError: (m) => { toast.error(m); setBusy(false); },
      onDismiss: () => setBusy(false),
    }, OPS);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="sm:max-w-md bg-white border-slate-200" data-testid="panel-topup-dialog">
        <DialogTitle className="text-slate-900">Top up your panel</DialogTitle>
        <DialogDescription className="text-sm text-slate-500">Pay real ₹ with Razorpay (UPI, card, netbanking). Credits you hand out or sell are taken from this balance.</DialogDescription>
        <div className="flex flex-wrap gap-2">
          {CHIPS.map((c) => (
            <button key={c} type="button" onClick={() => setCredits(c)} data-testid={`panel-topup-chip-${c}`}
              className={`h-8 px-3 rounded-full text-xs font-mono transition-colors ${n === c ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{c.toLocaleString("en-IN")}</button>
          ))}
        </div>
        <label className="text-xs text-slate-500 space-y-1.5 block">Any amount of credits
          <input type="number" min={1} step={1} value={credits} onChange={(e) => setCredits(e.target.value)} data-testid="panel-topup-credits"
            className="w-full h-11 px-3 rounded-xl bg-slate-50 border border-slate-200 text-base font-mono text-slate-900 outline-none focus:border-sky-400 focus:bg-white" /></label>
        <p className="text-xs text-slate-500" data-testid="panel-topup-price">₹{price} per credit (your cost) · You pay <b className="text-slate-900">₹{ok ? amount.toLocaleString("en-IN") : "—"}</b></p>
        <button onClick={pay} disabled={!ok || busy || !price} data-testid="panel-topup-pay"
          className="w-full h-11 rounded-full bg-slate-900 text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-slate-700 disabled:opacity-50 transition-colors">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Zap size={15} className="fill-amber-400 text-amber-400" />} Pay ₹{ok ? amount.toLocaleString("en-IN") : "—"}
        </button>
      </DialogContent>
    </Dialog>
  );
};

export default PanelTopupDialog;
